/**
 * @file: 商品组件销毁
 * @author: xiaolong.huang@dmall.com
 */

import Message from './message/index';

function goodsDestroy(cube: FreeObjMap): boolean {
    Message.unbind(cube);

    return true;
}

export default goodsDestroy;
